export function toName(str) {
  return (str || '').replace(/_+/g, '_').replace(/_([a-zA-Z])/g, v => v[1].toUpperCase()).replace(/([a-z])([A-Z])/g, v => `${v[0]} ${v[1]}`);
}